import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import Completed from "./images/completed.svg";
import Location from "./images/location-icon.svg";
import Calendar from "./images/calendar.svg";

const PickupSchedulePopup = ({
    address,
    pickupDate,
    title = ""
}) => {

    return (
        <div styleName={"styles.documentPopupWrapper"}>
            <div styleName={"styles.documentHeader"}>
                <img src={Completed} alt="completed" />
                {title && <h4>{title}</h4>}
            </div>
            <div styleName={"styles.pickupWrapper"}>
                {address && <React.Fragment>
                    <p>Pickup location</p>
                    <div styleName={"styles.pickupDetails"}>
                        <img src={Location} alt="Edit"/>
                        <span>{address}</span>
                    </div>
                </React.Fragment>}
                {pickupDate && <React.Fragment>
                    <p>Pickup date & time</p>
                    <div styleName={"styles.pickupDetails"}>
                        <img src={Calendar} alt="Calendar"/>
                        <span>{pickupDate}</span>
                    </div>
                </React.Fragment>}
            </div>
            <p styleName={"styles.note"}><strong>Note:</strong> If you want to reschedule pickup, you can do in next steps</p>
        </div>
    );
};

PickupSchedulePopup.propTypes = {
    pickupDate: PropTypes.any,
    address: PropTypes.any,
    title: PropTypes.string
};

export default PickupSchedulePopup;
